<template>
    <div class="setting-component">
        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
              <el-row style="margin-bottom: 20px">
                <el-col :span="24">
                  <div class="nav-tree">
                    <el-button v-if="companyLayout" :disabled="!companyLayout.permission.createBusinessUnits" @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_businessUnits_add')}} {{btnText}}</el-button>
                  </div>
                  <el-table
                          :data="tableData"
                          style="width: 100%"
                          height="400"
                          highlight-current-row
                          :empty-text="$t('general_noData')"
                          @current-change="handleCurrentChange">
                      <el-table-column
                        label="ID"
                        type="index"
                        width="50">
                      </el-table-column>
                      <el-table-column
                              prop="code"
                              :label="$t('settings_businessUnits_code')"
                              width="100">
                      </el-table-column>
                      <el-table-column
                              prop="name"
                              sortable
                              :label="$t('settings_businessUnits_name')">
                      </el-table-column>
                      <el-table-column
                              prop="managerName"
                              :label="$t('settings_businessUnits_manager')"
                              width="250">
                      </el-table-column>
                      <el-table-column
                              prop="createDate"
                              sortable
                              :label="$t('settings_businessUnits_dateCreated')"
                              width="150">
                      </el-table-column>
                      <el-table-column
                              width="190"
                              :label="$t('settings_businessUnits_operations')">
                          <template slot-scope="scope">
                            <!-- <el-button
                                      size="mini"
                                      plain
                                      icon="el-icon-info"
                                      @click="handleInfo(scope.row)"></el-button> -->
                              <el-button
                                  size="mini"
                                  type="primary"
                                  plain
                                  v-if="companyLayout"
                                  :disabled="!companyLayout.permission.updateBusinessUnits"
                                  @click="removeUserFromBUOpenModal(scope.$index, scope.row)">
                                <i class="el-icon-remove-outline el-icon-left"></i>
                                <i class="el-icon-user el-icon-right"></i>
                              </el-button>
                              <el-button
                                      size="mini"
                                      type="primary"
                                      plain
                                      icon="el-icon-edit"
                                      v-if="companyLayout"
                                      :disabled="!companyLayout.permission.updateBusinessUnits"
                                      @click="handleEdit(scope.$index, scope.row)"></el-button>
                              <el-button
                                      v-if="!scope.row.isService && companyLayout"
                                      size="mini"
                                      type="danger"
                                      plain
                                      icon="el-icon-delete"
                                      :disabled="!companyLayout.permission.deleteBusinessUnits"
                                      @click="handleDelete(scope.$index, scope.row)"></el-button>
                          </template>
                      </el-table-column>
                  </el-table>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-tabs activeName="info" disabled>
                    <el-tab-pane :label="$t('settings_businessUnits_info')" name="info">
                    <div class="user-info" v-if="showInfo">
                        <div class="user-info__content">
                            <div class="user-info__details">
                                <ul>
                                    <li><div :class="{isEmpty: !info.name}" class="user-info__details_label">{{$t('settings_businessUnits_name')}}:</div> <span class="user-info__details_all" v-html="info.name"></span></li>
                                    <li><div :class="{isEmpty: !info.businessCenter}" class="user-info__details_label">{{$t('settings_businessUnits_businessCenter')}}:</div> <span class="user-info__details_all" v-html="info.businessCenter"></span></li>
                                    <li><div :class="{isEmpty: !info.code}" class="user-info__details_label">{{$t('settings_businessUnits_code')}}:</div> <span class="user-info__details_all" v-html="info.code"></span></li>
                                    <!-- <li><div :class="{isEmpty: !info.description}" class="user-info__details_label">{{$t('settings_businessUnits_description')}}:</div> <span class="user-info__details_all" v-html="info.description"></span></li> -->
                                    <li><div :class="{isEmpty: !info.createDate}" class="user-info__details_label">{{$t('settings_businessUnits_dateCreated')}}:</div> <span class="user-info__details_all" v-html="info.createDate"></span></li>
                                    <li><div :class="{isEmpty: !info.phone}" class="user-info__details_label">{{$t('settings_businessUnits_phone')}}:</div> <span class="user-info__details_all" v-html="info.phone"></span></li>
                                    <li><div :class="{isEmpty: !info.extension}" class="user-info__details_label">{{$t('settings_businessUnits_phoneExtension')}}:</div> <span class="user-info__details_all" v-html="info.extension"></span></li>
                                    <li><div :class="{isEmpty: !info.email}" class="user-info__details_label">{{$t('settings_businessUnits_email')}}:</div> <span class="user-info__details_all" v-html="info.email"></span></li>
                                    <li><div :class="{isEmpty: !info.manager}" class="user-info__details_label">{{$t('settings_businessUnits_manager')}}:</div> <span class="user-info__details_all" v-html="info.manager"></span></li>
                                    <li><div :class="{isEmpty: !info.team.length}" class="user-info__details_label">{{$t('settings_businessUnits_team')}}:</div> <span class="user-info__details_all" v-for="team in info.team" :key="team.id">{{team.userFullName}} </span></li>
                                    <li><div :class="{isEmpty: !info.clients.length}" class="user-info__details_label">{{$t('settings_businessUnits_clients')}}:</div> <span class="user-info__details_all" v-for="clients in info.clients" :key="clients.id">{{clients.companyClient.name}} </span></li>
                                    <li><div :class="{isEmpty: !info.vendors.length}" class="user-info__details_label">{{$t('settings_businessUnits_vendors')}}:</div> <span class="user-info__details_all" v-for="vendors in info.vendors" :key="vendors.id">{{vendors.companyVendor.name}} </span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('settings_businessUnits_about')" name="about">
                      <div v-if="info" v-html="!info.description ? emtyDescription : info.description"></div>
                    </el-tab-pane>
                  </el-tabs>
                </el-col>
              </el-row>

            </div>
        </div>

        <!-- edit -->
        <sweet-modal blocking :title="`${$t('modal_businessUnits_edit')} ${btnText}`" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
            <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <el-input :disabled="isService" :label="$t('modal_businessUnits_businessUnitName')" v-model="formEdit.name"></el-input>
                    <i v-show="isService" @click="openInfoModal" class="el-icon-info icon-i"></i>
                </el-form-item>
                <!-- <el-form-item prop="code">
                    <el-input :placeholder="paleceholderText + ' code'" v-model="formEdit.code"></el-input>
                </el-form-item> -->

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="code">
                      <el-input :label="$t('modal_businessUnits_code')" maxlength="30" show-word-limit v-model="formEdit.code"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="businessCenterId">
                      <el-select no-data-text="no date" v-model="formEdit.businessCenterId" :placeholder="$t('modal_businessUnits_businessCenter')" style="width: 100%;">
                        <el-option
                          v-for="item in formEdit.businessCenters"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- // TODO: Description -->
                <el-form-item>
                  <el-button v-on:click="$refs.nestedChildEdit.open()" style="width: 100%;">{{$t('modal_businessUnits_businessUnitDescription')}}</el-button>
                </el-form-item>

                <el-form-item prop="phone">
                  <el-input :label="$t('modal_businessUnits_phone')" v-model="formEdit.phone"></el-input>
                </el-form-item>
                <el-form-item prop="phoneExtension">
                  <el-input :label="$t('modal_businessUnits_extension')" v-model="formEdit.phoneExtension"></el-input>
                </el-form-item>

                <el-form-item prop="email">
                  <el-input :label="$t('modal_businessUnits_email')" v-model="formEdit.email"></el-input>
                </el-form-item>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="managerId">
                      <el-select v-model="formEdit.managerId" :placeholder="$t('modal_businessUnits_manager')" style="width: 100%;">
                        <el-option
                          v-for="item in formEdit.managers"
                          :key="item.id"
                          :label="item.user.fullName"
                          :value="item.id"
                          :class="{ disabled: item.status != 1 }"
                          @click.native="handleSelectManagerEdit(item.id)"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="teamId">
                      <el-select no-data-text="no date"
                                 @remove-tag="removeTagEdit"
                                 v-model="formEdit.teamId"
                                 multiple
                                 :placeholder="$t('modal_businessUnits_team')"
                                 style="width: 100%;">
                        <el-option
                          v-for="item in formEdit.team"
                          :key="item.id"
                          :label="item.user.fullName"
                          :value="item.id"
                          :disabled="item.isDisabled"
                          :class="{ disabled: item.status !== 1 || item.isDisabled }"
                          @click.native="handleSelectTeamEdit(item.id)">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <!-- prop="clientsId" -->
                    <el-form-item>
                      <el-select no-data-text="no date" v-model="formEdit.clientsId" multiple :placeholder="$t('modal_businessUnits_clients')" style="width: 100%;">
                        <el-option
                          v-for="item in formEdit.clients"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="vendorsId">
                      <el-select no-data-text="no date" v-model="formEdit.vendorsId" multiple :placeholder="$t('modal_businessUnits_vendors')" style="width: 100%;">
                        <el-option
                          v-for="item in formEdit.vendors"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                    <el-form-item prop="profitCentre">
                        <el-col :span="24">
                            <el-checkbox v-model="formEdit.profitCentre">{{$t('modal_businessUnits_profitCentre')}}</el-checkbox>
                        </el-col>
                    </el-form-item>
                </el-row>

                <el-row v-if="formEdit.profitCentre">
                    <el-form-item prop="bill">
                        <el-col :span="24">
                            <el-radio-group v-model="formEdit.bill">
                                <el-radio :label="0">{{$t('modal_businessUnits_singleBill')}}</el-radio>
                                <el-radio :label="1">{{$t('modal_businessUnits_progressBilling')}}</el-radio>
                                <!--<el-radio :label="2">Not Billable</el-radio>-->
                            </el-radio-group>
                        </el-col>
                    </el-form-item>
                </el-row>

                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('openModalEdit')">{{$t('modal_businessUnits_cancel')}}</el-button>
                    <el-button @click="editItem('formEdit')" type="primary">{{$t('modal_businessUnits_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <sweet-modal title="tf Support" width="500" blocking ref="buName">
          <div class="tf-support">
            <div>Administration and Document Managers are default system created Business Units and cannot be renamed.</div>
            <br>
            <div>For more information click on the link below</div>
            <div><a href="https://totalflow.io/businessunits" target="_blank">www.totalflow.io/businessunits</a></div>
          </div>
        </sweet-modal>

        <!-- desc add -->
        <!--<sweet-modal blocking ref="nestedChild">-->
            <!--<vue-editor-->
              <!--v-model="form.description"-->
              <!--useCustomImageHandler-->
              <!--@image-added="handleImageAdded"-->
            <!--&gt;</vue-editor>-->
            <!--<el-button slot="button" v-on:click="$refs.nestedChild.close()" type="primary">{{$t('modal_businessUnits_submit')}}</el-button>-->
        <!--</sweet-modal>-->

        <!-- desc edit -->
        <sweet-modal blocking ref="nestedChildEdit">
            <vue-editor
              v-model="formEdit.description"
              useCustomImageHandler
              @image-added="handleImageAdded"
            ></vue-editor>
            <el-button slot="button" v-on:click="$refs.nestedChildEdit.close()" type="primary">{{$t('modal_businessUnits_submit')}}</el-button>
        </sweet-modal>

        <!-- About this Business Unit -->
        <sweet-modal blocking :title="`${$t('modal_businessUnits_businessUnitDescription')}`" ref="info">
            <div v-if="info" v-html="!info.description ? emtyDescription : info.description"></div>
        </sweet-modal>

        <create-business-unit-modal-wizzard ref="addBusinessUnit" @loadList="loadList"/>

        <disabled-projects-engagements-modal ref="disabledProjectsEngagementsModal"/>

        <remove-user-from-b-u-modal ref="removeUserFromBUModal" @loadList="loadList"/>
    </div>
</template>

<script>
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  import CreateBusinessUnitModalWizzard from "./businessUnits/CreateBusinessUnitModalWizzard";
  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import { VueEditor } from 'vue2-editor'
  import DisabledProjectsEngagementsModal from "./disabledProjectsEngagementsModal/index";
  import RemoveUserFromBUModal from "./businessUnits/RemoveUserFromBUModal";

  export default {
    components: {
      RemoveUserFromBUModal,
      DisabledProjectsEngagementsModal,
      CreateBusinessUnitModalWizzard,
      // Header,
      // Menu,
      SweetModal,

      VueEditor,
    },
    beforeCreate() {},
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      }
    },
    data() {
      return {
        isService: false,
        emtyDescription: this.$i18n.t('noDetailsProvided'),
        showInfo: false,
        currentRow: null,
        paleceholderText: this.$i18n.t('settings_businessUnits'),
        btnText:this.$i18n.t('settings_businessUnits'),
        tableData: [],
        selectedRowId: '',
        moment:moment,
        serviceIndex: null,
        formEdit:{
          bill: 0,
          profitCentre: false,
          name: '',
          code: '',
          businessCenters: [],
          businessCenterId: '',
          description: '',
          phone: '',
          phoneExtension: '',
          email:'',
          managers: [],
          managerId:'',
          team:'',
          teamId:[],
          clients:'',
          clientsId: [],
          vendors: '',
          vendorsId: [],
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          code: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          businessCenterId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          managerId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          teamId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          clientsId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ]
        },
        info: {
          name: null,
          businessCenter: null,
          code: null,
          description: null,
          createDate: null,
          extension: null,
          phone: null,
          email: null,
          manager: null,
          team: [],
          taskTree: null,
          clients: [],
          vendors: [],
        }
      }
    },
    methods: {
      openInfoModal() {
        this.$refs.buName.open();
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        console.log("FILE",file);
        // this.form.imageUrl = URL.createObjectURL(file.raw);
        // console.log('---', this.form.imageUrl);
        var formData = new FormData();
        formData.append('file', file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            let url = response.data.fileUrl; // Get url from response
            Editor.insertEmbed(cursorLocation, 'image', url);
            resetUploader();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
      handleCurrentChange(val) {
        if (!val) return;
        this.currentRow = val;
        console.log('---handleCurrentChange', val);

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnits/extendedInfo?companyId=${this.$route.query.companyId}&businessUnitId=${val.id}`)
            .then(response => {
                console.log('---/businessUnits/extendedInfo', response.data.extendedInfo);
                this.info.name = response.data.extendedInfo.name
                this.info.businessCenter = response.data.extendedInfo.businessCenterList
                this.info.code = response.data.extendedInfo.code
                this.info.description = response.data.extendedInfo.description
                this.info.createDate = moment(response.data.extendedInfo.createDate.toString(), 'X').format('DD MMMM YYYY')
                this.info.extension = response.data.extendedInfo.phone2
                this.info.phone = response.data.extendedInfo.phone
                this.info.email = response.data.extendedInfo.email
                this.info.manager = response.data.extendedInfo.managerUser.user.fullName
                this.info.team = response.data.extendedInfo.businessUnitCompanyUserList
                // this.info.taskTree = response.data.extendedInfo.taskTree
                this.info.clients = response.data.extendedInfo.businessUnitCompanyClientList
                this.info.vendors = response.data.extendedInfo.businessUnitCompanyVendorList
            })
            .catch(error => {
                console.log('An error occurred:', error);
            });

        this.showInfo = true
      },
      loadList(){
        this.showInfo = false;
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
            .then(response => {
              let list = response.data.list;
              for (let i = 0; i < list.length; i++) {
                list[i].createDate = moment(list[i].createDate.toString(), 'X').format('YYYY/MM/DD');
              }
              this.tableData = response.data.list
              loader.hide()
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnits/create?companyId=${this.$route.query.companyId}`, {
                // companyId: this.$route.query.companyId,
                // name: this.form.name,
                // code: this.form.code,

                name: this.form.name,
                description: this.form.description,
                phone: this.form.phone,
                phone2: this.form.phoneExtension,
                email: this.form.email,
                managerCompanyUserId: this.form.managerId,
                companyUserIdList: this.form.teamId,
                businessUnitTemplateId: this.form.taskTreeId,
                businessCenterIdList: [this.form.businessCenterId],
                code: this.form.code,
                companyClientIdList: this.form.clientsId,
                companyVendorIdList: this.form.vendorsId,
                profitCentre: this.form.profitCentre ? 1 : 0,
                bill: this.form.bill,
              })
              .then(async response => {
                try {
                  await this.$store.dispatch('getCompanyLayout')
                  this.loadList();
                  this.$refs.openModal.close();
                  loader.hide()
                } catch (err){
                  loader.hide();
                  console.log(err)
                }
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      openModalAdd(){
        this.$refs.addBusinessUnit.openModal();
      },
      // closeModal(){
      //   this.form.description = '';
      //   this.$refs['form'].resetFields();
      // },
      closeModalEdit(){
        this.formEdit.description = '';
        this.$refs['formEdit'].resetFields();
      },
      handleInfo(row) {
        // eslint-disable-next-line no-console
        // console.log('---WWWWWWWWWWWWWWWWWWW', row)
        this.$refs.info.open()
      },
      handleEdit(index, row) {
        console.log(row);
        let loader = this.$loading.show();

        if (row.isService) {
          this.isService = true
        } else {
          this.isService = false
        }

        this.selectedRowId = row.id;

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnits/directories?companyId=${this.$route.query.companyId}&operation=update&businessUnitId=${row.id}`)
            .then(response => {
                console.log('---', response.data);
                loader.hide()
                if (response.data.success) {
                    console.log("success");
                    this.formEdit.businessCenters = response.data.businessCenterList;
                    this.formEdit.managers = response.data.companyUserList;
                    this.formEdit.team = response.data.companyUserList;
                    this.formEdit.taskTree = response.data.businessUnitTemplateList;
                    this.formEdit.clients = response.data.companyClientList;
                    this.formEdit.vendors = response.data.companyVendorList;
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                    axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                    axios
                      .post(`/api/v1/businessUnits/item?companyId=${this.$route.query.companyId}&businessUnitId=${row.id}`)
                      .then(response => {
                        this.formEdit.name = response.data.item.name;
                        this.formEdit.code = response.data.item.code;
                        this.formEdit.description = response.data.item.description;
                        this.formEdit.phone = response.data.item.phone;
                        this.formEdit.phoneExtension = response.data.item.phone2;
                        this.formEdit.email = response.data.item.email;
                        this.formEdit.profitCentre = response.data.item.profitCentre === 1;
                        this.formEdit.managerId = response.data.item.managerCompanyUserId;
                        this.formEdit.businessCenterId = response.data.item.businessCenterIdList[0];
                        this.formEdit.teamId = response.data.item.companyUserIdList;
                        this.formEdit.clientsId = response.data.item.companyClientIdList;
                        this.formEdit.vendorsId = response.data.item.companyVendorIdList;
                        this.formEdit.bill = response.data.item.bill;

                        // disable bu selected users
                        this.formEdit.team.forEach(bal => {
                          bal.isDisabled  = response.data.item.companyUserIdList.some(val => val === bal.id)
                        })

                        this.$refs.openModalEdit.open()
                      })
                      .catch(error => {
                        console.log('An error occurred:', error);
                      });
                }
            })
            .catch(error => {
              loader.hide()
              console.log('An error occurred:', error);
            });
      },
      removeUserFromBUOpenModal(index, row) {
        this.$refs.removeUserFromBUModal.openModal(this.$route.query.companyId, row.id)
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnits/update?companyId=${this.$route.query.companyId}&businessUnitId=${this.selectedRowId}`, {
                name: this.formEdit.name,
                description: this.formEdit.description,
                phone: this.formEdit.phone,
                phone2: this.formEdit.phoneExtension,
                email: this.formEdit.email,
                managerCompanyUserId: this.formEdit.managerId,
                companyUserIdList: this.formEdit.teamId,
                businessCenterIdList: [this.formEdit.businessCenterId],
                code: this.formEdit.code,
                companyClientIdList: this.formEdit.clientsId,
                companyVendorIdList: this.formEdit.vendorsId,
                bill: this.formEdit.bill,
                profitCentre: this.formEdit.profitCentre ? 1 : 0,
              })
              .then(response => {
                this.$refs.openModalEdit.close();
                this.loadList();
                loader.hide()
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        this.selectedRowId = row.id

        this.$confirm(this.$t('settings_businessUnits_ThisWillPermanentlyDeleteTheTemplatesContinue'), this.$t('settings_businessUnits_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('modal_businessUnits_cancel'),
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/businessUnits/delete?companyId=${this.$route.query.companyId}&businessUnitId=${this.selectedRowId}`)
            .then(response => {
              // check if project or bu's attached
              if (response.data.engagements || response.data.projects) {
                this.$refs.disabledProjectsEngagementsModal.openModal(response.data.projects, response.data.engagements)
              } else {
                this.loadList();
                this.$message({
                  type: 'success',
                  message: this.$t('settings_businessUnits_deleteCompleted')
                });
              }
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('settings_businessUnits_deleteCompleted')
          });
        });
      },
      // handleSelectManager(leaderId){
      //   const even = (element) => element === leaderId;
      //   const ifUserInTeam = this.form.teamId.some(even);
      //   if (!ifUserInTeam) {
      //     this.form.teamId.push(leaderId)
      //   }
      // },
      // handleSelectTeam(userId){
      //   const even = (element) => element === userId;
      //   const ifUserInTeam = this.form.teamId.some(even);
      //   if(!ifUserInTeam && this.form.managerId === userId) {
      //     this.form.managerId = null
      //   }
      // },
      // removeTag(userId){
      //   if(this.form.managerId === userId) {
      //     this.form.managerId = null
      //   }
      // },
      handleSelectManagerEdit(leaderId){
        const even = (element) => element === leaderId;
        const ifUserInTeam = this.formEdit.teamId.some(even);
        if (!ifUserInTeam) {
          this.formEdit.teamId.push(leaderId)
        }
      },
      handleSelectTeamEdit(userId){
        const even = (element) => element === userId;
        const ifUserInTeam = this.formEdit.teamId.some(even);
        if(!ifUserInTeam && this.formEdit.managerId === userId) {
          this.formEdit.managerId = null
        }
      },
      removeTagEdit(userId){
        // check if try to remove existed user
        if (this.formEdit.team.some((val) => val.id === userId && val.isDisabled)) {
          return this.formEdit.teamId.push(userId)
        }

        if(this.formEdit.managerId === userId) {
          this.formEdit.managerId = null
        }
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
    // watch:{
    //   tableData(val){
    //     val.forEach(i =>{
    //       i.createDate = moment(i.createDate.toString(), 'X').format('DD MMMM YYYY')
    //     })
    //   }
    // }
  }
</script>

<style lang="scss" scoped>
  .setting-component{
    min-width:810px;
  }

  .isEmpty {
    color: #ccc
  }

  .user-info {
    &__title {
      margin-top: 0;
    }
    &__content {
      display: flex;
    }
    &__photo {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      margin-right: 20px;
      background: url('~@/assets/img/user-default.jpg');
      background-size: cover;
      img {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        // background: url('~@/assets/img/user-default.jpg');
        background-size: cover;
      }
    }
    &__details {
      .isEmpty {
          color: #ccc
      }
      &_label {
        display: inline-block;
        width: 150px;
      }
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        color: #888;
        li {
          margin-bottom: 8px;
          span {
            font-weight: 500;
          }
        }
      }
      &_email {
        font-weight: bold;
        background: #888;
        color: white;
        border-radius: 5px;
        padding: 3px;
      }
      &_status {
        font-weight: bold;
        background: #5cb85c;
        color: white;
        border-radius: 5px;
        padding: 3px;
      }
      &_all {
        font-weight: bold;
      }
    }
  }
  p {
    img {
      max-width: 100%;
    }
  }
  .icon-i {
    position: absolute;
    top: 13px;
    right: 13px;
    cursor: pointer;
  }
  .tf-support {
    font-size: 20px;
  }
</style>
